var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      attrs: { id: "deductions-card", "no-body": "" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t(
                        "direct-to-lender.commissions.sectionNames.deductions"
                      )
                    ) +
                    "\n    "
                ),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _c("div", { staticClass: "d-flex justify-content-end" }, [
                _c("span", { staticClass: "text-primary bold" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.commissions.deductions.totalDeductions"
                        )
                      ) +
                      ":\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "bold ml-1" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("formatMoneyValueLong")(
                          _vm.totalCommissionDeduction
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.loading
        ? _c("commission-deductions-loader", { staticClass: "p-4" })
        : _c("commission-deductions", {
            attrs: {
              "client-username": _vm.clientUsername,
              "application-id": _vm.applicationId,
              "current-commissions-mortgage-type":
                _vm.currentCommissionsMortgageType,
              "is-read-only": _vm.isReadOnly,
            },
            on: { update: _vm.updateDeductions },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }